import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpMethod } from 'src/constants/constant';
import configJSON from '../config/config.json';
import { environment } from 'src/environments/environment';
import {
  HttpCustomOptions,
  HttpInterceptorService,
} from './http-interceptor/http-interceptor.service';
@Injectable({
  providedIn: 'root',
})
export class ServiceManagerService {
  /**
   * Creates an instance of service manager service.
   * @param httpCommonService
   */
  constructor(private httpCommonService: HttpInterceptorService) {}

  /**
   * Calls backend service api
   * @param serviceName
   * @param body
   * @param [customOptions]
   * @param [authTokenRequired]
   * @returns
   */
  public CallBackendServiceAPI(
    serviceName: string,
    body: any,
    customOptions?: HttpCustomOptions,
    authTokenRequired: boolean = true
  ) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    var apiList: any = configJSON['api'];
    const endpointURL = this.getBackendUrl() + apiList[serviceName]['url'];
    const defaultCustomOptions: HttpCustomOptions = {
      showErrorMessage: true,
      showSuccessMessage: false,
      createLoaderAction: true,
    };
    switch (apiList[serviceName]['method']) {
      case HttpMethod.GET:
        return this.httpCommonService.get(
          endpointURL,
          httpOptions,
          customOptions || defaultCustomOptions
        );
      case HttpMethod.PUT:
        return this.httpCommonService.put(
          endpointURL,
          body,
          httpOptions,
          customOptions || defaultCustomOptions
        );
      case HttpMethod.DELETE:
        return this.httpCommonService.delete(
          endpointURL,
          httpOptions,
          customOptions || defaultCustomOptions
        );
      default:
        return this.httpCommonService.post(
          endpointURL,
          body,
          httpOptions,
          customOptions || defaultCustomOptions
        );
    }
  }

  /**
   * Gets backend url
   * @returns
   */
  getBackendUrl() {
    return environment.baseUrl + configJSON.basic.base_url;
  }
}
